export const supplierRootPages = [
  {
    path: '/supplier',
    children: [
      {
        path: ':supplierId',
        component: () => import('@/views/supplier/TheSupplierViewPage.vue'),
        name: 'supplier_view_route',
        props: true
      }
    ]
  }
]
